<template>
  <div>
    <slot name="form">
      <v-dialog persistent eager v-model="dialog" max-width="700">
        <turno-examen-form ref="form" :id="id" @close="cerrar">
        </turno-examen-form>
      </v-dialog>
    </slot>

    <v-card>
      <v-card-title>
        Turnos de Examen
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <slot name="buttons">
          <v-row>
            <v-col align="left">
              <v-btn @click="newItem" color="primary">Nuevo</v-btn>
            </v-col>
          </v-row>
        </slot>

        <v-row>
          <v-col>
            <v-text-field
              label="Buscar"
              v-model="search.tag"
              clearable
              @click:clear="reload"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          v-model="selectedItems"
          show-select
          :loading="loading.status"
          :items="turnoExamenes"
          :headers="headers"
          :server-items-length="pagination.totalCount"
          :options.sync="options"
        >
          <template v-slot:body.prepend>
            <tr>
              <td></td>
              <td v-for="(filterCol, i) in headers" :key="i">
                <v-text-field
                  v-show="filterCol.filterable"
                  hide-details
                  filled
                  :label="'Buscar por ' + filterCol.text"
                  v-model="
                    like[filterCol.table ? filterCol.table : filterCol.value]
                  "
                  clearable
                  @click:clear="reload"
                ></v-text-field>
              </td>
            </tr>
          </template>

          <template v-slot:item.carrera="{ item }">
            {{ item.carrera ? item.carrera.nombre : "-" }}
          </template>

          <template v-slot:item.tipo="{ item }">
            <v-chip
              :color="item.tipo === 'regular' ? 'primary' : 'warning'"
              small
            >
              {{ item.tipo === "regular" ? "Regular" : "Extraordinaria" }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon color="info" class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon color="error" @click="deleteItem(item.id)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import TurnoExamenForm from "@/viewsNew/turno-examen/TurnoExamenForm";

export default {
  name: "TurnoExamenABM",
  components: { TurnoExamenForm },
  data() {
    return {
      selectedItems: [],
      like: {},
      dialog: false,
      id: null,
      options: {
        joins: [],
      },
      expand: ["carrera"],
    };
  },
  computed: {
    ...mapState("TurnoExamenModule", ["turnoExamenes", "pagination"]),
    ...mapState(["search", "filters", "loading", "dialogs"]),

    filterHeaders() {
      return this.headers.filter((el) => el.filterable);
    },

    headers() {
      return [
        { text: "Id", value: "id", filterable: true },
        { text: "Carrera", value: "carrera", filterable: false },
        { text: "Nombre", value: "nombre", filterable: true },
        { text: "Tipo", value: "tipo", filterable: true },
        { text: "Anio", value: "anio", filterable: true },
        { text: "Mes", value: "mes", filterable: true },
        {
          text: "Inicio Inscripcion",
          value: "fecha_inicio_inscripcion",
          filterable: false,
        },
        {
          text: "Fin Inscripcion",
          value: "fecha_fin_inscripcion",
          filterable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          filterable: false,
          nosearch: true,
        },
      ];
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$refs.form.model = {
          tipo: "regular",
          anio: new Date().getFullYear(),
          mes: null,
          carrera_id: null,
        };
        this.$refs.form.carrerasSeleccionadas = [];
        this.id = null;
      }
    },
    filters: {
      handler() {
        this.setFilters();
        this.reload();
      },
      deep: true,
    },
    like: {
      handler() {
        this.reload();
      },
      deep: true,
    },
    search: {
      handler() {
        this.setSearch();
        this.reload();
      },
      deep: true,
    },
    options: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("TurnoExamenModule", [
      "getTurnoExamenes",
      "deleteTurnoExamen",
    ]),
    ...mapMutations(["clearFilters", "setFilters", "setSearch"]),

    newItem() {
      this.$refs.form.model = {
        tipo: "regular",
        anio: new Date().getFullYear(),
        mes: null,
        carrera_id: null,
      };
      this.$refs.form.carrerasSeleccionadas = [];
      this.dialog = true;
    },

    cerrar() {
      this.dialog = false;
      this.reload();
    },

    editItem(item) {
      this.id = item.id;
      this.dialog = true;
    },

    async deleteItem(id) {
      const res = await this.$dialog.confirm({
        color: "error",
        icon: "mdi-alert",
        text: "Esta seguro que desea eliminar el registro?",
        title: "Eliminar Registro",
      });
      if (res) {
        this.deleteTurnoExamen(id);
      }
    },

    async reload() {
      this.loading.status = true;
      await this.getTurnoExamenes({
        like: this.like,
        options: this.options,
        filters: this.filters,
        expand: this.expand.toString(),
        search: this.search.tag,
        headers: this.headers,
      });
      this.loading.status = false;
    },
  },
  destroyed() {
    this.clearFilters();
  },
};
</script>

<style scoped></style>
